import { ServerFileProvider } from "./serverProvider";

export class DesktopProvider extends ServerFileProvider{
    constructor (){
        super('', 'Desktop');
    }

    get providerName(){
        return 'desktop'
    }
}